export default "__VITE_ASSET__uBiMNBjX__"